import { MDBCol, MDBInput, MDBRow, MDBSelect } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { getMisc } from "../../../../apiclients/streamsapi_bridge";

function NumbersServiceAddress({
  register,
  errors,
  watch,
  setValue,
  portingType,
  clearErrors,
}) {
  const navigate = useNavigate();
  const [states, setstates] = useState([]);

  async function fetchStates() {
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["states"] }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log(
      "data :::::::::::::::::::::::::::::::::::::::::::::::::::::: " +
        JSON.stringify(tdata)
    );
    const transformedBillingGroups = (tdata.misc.states || []).map((entry) => ({
      text: entry.statename,
      value: entry.statename,
    }));
    setstates(tdata.misc.states);
  }

  useEffect(() => {
    fetchStates();
  }, []);
  return (
    <>
      <div className="pb-3">
        <h5>Enter Service Address {portingType === 3 ? "(Optional)" : ""}</h5>
        <p className="small my-3 text-secondary">
          For Security purposes, your current service provider requires you to
          enter the following info EXACTLY as they have in Copy of Bill or CSR.
          You may need to contact your service provider to get specifies
        </p>
        <p className="mt-3">
          Provide the physical service address of the Phone number.
          <span className="text-danger">
            {" "}
            Do not enter billing addresses or P.O. boxes.
          </span>
        </p>
        <MDBRow>
          {/* Row 1: Floor Number | Suite */}
            {portingType !== 3 && (
              <>
              <MDBCol size={6}>
                <div className="tel-numbers mt-2">
                  <strong>Floor Number</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={30}
                  value={watch("service_addr.floor_num")}
                  onChange={(e) => {
                    clearErrors("service_addr.floor_num");
                    setValue("service_addr.floor_num", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.service_addr?.floor_num && (
                  <p className="text-danger">
                    {errors?.service_addr?.floor_num?.message}
                  </p>
                )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers mt-2">
                  <strong>Suite</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={30}
                  value={watch("service_addr.suite")}
                  onChange={(e) => {
                    clearErrors("service_addr.suite");
                    setValue("service_addr.suite", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.service_addr?.suite && (
                  <p className="text-danger">
                    {errors?.service_addr?.suite?.message}
                  </p>
                )}
              </MDBCol>
              </>
            )}

          {/* Row 2: Street Number | Street Name */}
          <MDBCol size={6}>
            <div className="tel-numbers mt-2">
              <strong>Street Number*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={250}
              value={watch("service_addr.street_num")}
              onChange={(e) => {
                clearErrors("service_addr.street_num");
                setValue("service_addr.street_num", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {errors?.service_addr?.street_num && (
              <p className="text-danger">
                {errors?.service_addr?.street_num?.message}
              </p>
            )}
          </MDBCol>
          <MDBCol size={6}>
            <div className="tel-numbers mt-2">
              <strong>Street Name*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={250}
              value={watch("service_addr.street_name")}
              onChange={(e) => {
                clearErrors("service_addr.street_name");
                setValue("service_addr.street_name", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {errors?.service_addr?.street_name && (
              <p className="text-danger">
                {errors?.service_addr?.street_name?.message}
              </p>
            )}
          </MDBCol>

          {/* Row 3: City | State/Province */}
          <MDBCol size={6}>
            <div className="tel-numbers mt-2">
              <strong>City*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={30}
              value={watch("service_addr.city")}
              onChange={(e) => {
                clearErrors("service_addr.city");
                setValue("service_addr.city", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {errors?.service_addr?.city && (
              <p className="text-danger">
                {errors?.service_addr?.city?.message}
              </p>
            )}
          </MDBCol>
          <MDBCol size={6}>
            <div className="tel-numbers mt-2">
              <strong>State/Province*</strong>
            </div>
            <select
              className="w-100 form-select"
              data={[{ text: "--Select state", value: "" }, ...states]}
              value={watch("service_addr.state")}
              onChange={(e) => {
                e.preventDefault();
                clearErrors("service_addr.state");
                setValue("service_addr.state", e.target.value, {
                  shouldDirty: true,
                });
              }}
            >
              <option value="">--Select state--</option>
              {states &&
                states.length > 0 &&
                states.map((entry) => (
                  <option value={entry.statename}>{entry.statename}</option>
                ))}
            </select>
            {errors?.service_addr?.state && (
              <p className="text-danger">
                {errors?.service_addr?.state?.message}
              </p>
            )}
          </MDBCol>

          {/* Row 4: ZIP | Carrier Account Number (portingType 2 only) */}
          <MDBCol size={6}>
            <div className="tel-numbers mt-2">
              <strong>ZIP/Postal Code*</strong>
            </div>
            <MDBInput
              type="text"
              maxLength={10}
              value={watch("service_addr.zip")}
              onChange={(e) => {
                clearErrors("service_addr.zip");
                setValue("service_addr.zip", e.target.value, {
                  shouldDirty: true,
                });
              }}
            />
            {errors?.service_addr?.zip && (
              <p className="text-danger">
                {errors?.service_addr?.zip?.message}
              </p>
            )}
          </MDBCol>
          {portingType === 2 && (
            <MDBCol size={6}>
              <div className="tel-numbers mt-2">
                <strong>Carrier Account Number*</strong>
              </div>
              <MDBInput
                type="text"
                maxLength={30}
                value={watch("service_addr.carrier_acc_num")}
                onChange={(e) => {
                  clearErrors("service_addr.carrier_acc_num");
                  setValue("service_addr.carrier_acc_num", e.target.value, {
                    shouldDirty: true,
                  });
                }}
              />
              {errors?.service_addr?.carrier_acc_num && (
                <p className="text-danger">
                  {errors?.service_addr?.carrier_acc_num?.message}
                </p>
              )}
            </MDBCol>
          )}

          {/* Carrier Name | Carrier PIN (portingType 2 only) */}
            {portingType === 2 && (
              <>
              <MDBCol size={6}>
                <div className="tel-numbers mt-2">
                  <strong>Carrier Name*</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={25}
                  value={watch("service_addr.carrier_name")}
                  onChange={(e) => {
                    clearErrors("service_addr.carrier_name");
                    setValue("service_addr.carrier_name", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.service_addr?.carrier_name && (
                  <p className="text-danger">
                    {errors?.service_addr?.carrier_name?.message}
                  </p>
                )}
              </MDBCol>
              <MDBCol size={6}>
                <div className="tel-numbers mt-2">
                  <strong>Carrier PIN</strong>
                </div>
                <MDBInput
                  type="text"
                  maxLength={30}
                  value={watch("service_addr.carrier_pin")}
                  onChange={(e) => {
                    clearErrors("service_addr.carrier_pin");
                    setValue("service_addr.carrier_pin", e.target.value, {
                      shouldDirty: true,
                    });
                  }}
                />
                {errors?.service_addr?.carrier_pin && (
                  <p className="text-danger">
                    {errors?.service_addr?.carrier_pin?.message}
                  </p>
                )}
              </MDBCol>
              </>
            )}
        </MDBRow>
      </div>
    </>
  );
}

export default NumbersServiceAddress;
